export const POST_ORG_ADMIN_RESULT_RELEASE_SEARCH_PARAM='POST_ORG_ADMIN_RESULT_RELEASE_SEARCH_PARAM';
export const GET_ORG_ADMIN_RESULT_RELEASE_BY_INDEX_NO='GET_ORG_ADMIN_RESULT_RELEASE_BY_INDEX_NO';
export const POST_BULK_DOWNLOAD_ORG_ADMIN_RESULT_RELEASE = 'POST_BULK_DOWNLOAD_ORG_ADMIN_RESULT_RELEASE';
export const GET_BULK_DOWNLOAD_FILE_STATUS_ORG_ADMIN_RESULT_RELEASE = 'GET_BULK_DOWNLOAD_FILE_STATUS_ORG_ADMIN_RESULT_RELEASE';
